import { render, staticRenderFns } from "./developerPage.vue?vue&type=template&id=60378e01&scoped=true&"
import script from "./developerPage.vue?vue&type=script&lang=js&"
export * from "./developerPage.vue?vue&type=script&lang=js&"
import style0 from "./developerPage.vue?vue&type=style&index=0&id=60378e01&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60378e01",
  null
  
)

export default component.exports